import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {LogService} from '../../services/log.service';
import {AppSettings} from '../../helpers/app-settings';
import {AuthService} from '../../auth/auth.service';
import {ErrorHandlingService} from '../common/error-handling.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private log: LogService, private appSettings: AppSettings, private authService: AuthService,
              private errorHandling: ErrorHandlingService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const api_token = this.authService.user?.access_token;

    // this.log.info('Se hace la consulta a: ', req.method.toUpperCase() + ' ' + req.url);
    // this.log.debug('Se envian los datos', req.serializeBody());

    return next.handle(req.clone({
      headers: req.headers.append('Authorization', 'Bearer ' + api_token).append('Accept', 'application/json')
    }))
      .pipe(
        map((event: HttpEvent<any>) => {
          // if (event instanceof HttpResponse && ~~(event.status / 100) > 3) {
          //     console.info('HttpResponse::event =', event, ';');
          // } else console.info('event =', event, ';');
          return event;
        }),
        catchError(((err: any, caught) => {
          if (err instanceof HttpErrorResponse) {

            if (err.status === 401) {
              this.authService.logout(false);
              location.reload(); // Se pone esto ya que no hace caso al navigate que hay en el logout
              return new Observable<HttpEvent<any>>(subscriber => subscriber.next());
            }
            return this.errorHandling.handleErrors(err);
          }
        }))
      );

  }

}
